export default {
  Contains: 'Contains',
  Equals: 'Equals',
  MatchRegularExpression: 'MatchRegularExpression',
  NotApplicable: 'NotApplicable',
  NotContains: 'NotContains',
  NotEquals: 'NotEquals'
}
